import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { BasketItem, Discount } from '../../../../types/basket';
import { config, getAssetUrl } from '../../../../utils/config';
import EllipsisText from '../../../atoms/EllipsisText';
import Price from '../../../atoms/Price';
import ToolTip from '../../../atoms/ToolTip';
import './style.scss';

export const getDiscounts = (discountComponents: Omit<Discount, 'total'>) =>
  Object.entries(discountComponents)
    .filter(
      ([key, value]) =>
        !!value && (config.basket.showNetPrices ? key.includes('WithoutTax') : !key.includes('WithoutTax'))
    )
    .map(([key, value]) => ({ key: key.replace('WithoutTax', ''), value }));

const ItemDiscounts = ({ item }: { item: BasketItem }) => {
  const { total, ...discountComponents } = item.discount;
  const { costWithoutTaxWithoutDiscount } = item.total;
  const { showNetPrices } = config.basket;

  const discounts = getDiscounts(discountComponents);
  const isDiscounted = !!discounts?.length;
  const totalWithoutDiscounts = showNetPrices ? costWithoutTaxWithoutDiscount : item.total.costWithTaxWithoutDiscount;

  const promotions = item.promotion?.filter(promotion => 'code' in promotion);
  const promotionsTotal = promotions?.reduce((partialSum, promotion) => partialSum + promotion.discount, 0);

  return (
    <>
      {isDiscounted && <Price price={totalWithoutDiscounts} isInactive dataTestId="price-discount" />}
      {isDiscounted &&
        !showNetPrices &&
        discounts.map(({ key, value }) => (
          <div className={classNames('discount', `discount--${key}`)} key={key} data-test-id={`discount-item-${key}`}>
            <FormattedMessage id={`basket.item.discount.${key}`} />
            <Price price={value * -1} isDiscount dataTestId={`price-discount-${key}`} />
          </div>
        ))}
      {!!promotions?.length && !showNetPrices && (
        <div className="basket-item-promotions">
          {promotions.length > 1 ?
            <ToolTip
              centered
              hideHeadlineIcon
              headline={
                <FormattedMessage id="payment.promotion.activeDiscounts" values={{ number: promotions.length }} />
              }
              content={
                <div className="promotions-content">
                  {promotions.map(({ id, name, discount }) => (
                    <div className="promotions-content__item" key={id}>
                      <EllipsisText className="promotions-content__name">
                        {name ?? <FormattedMessage id="payment.promotion.fallbackCodeName" />}
                      </EllipsisText>
                      <Price className="promotions-content__price" price={discount * -1} />
                    </div>
                  ))}
                  <hr className="promotions-content__divider"></hr>
                  <div className="promotions-content__total">
                    <FormattedMessage id="payment.promotion.totalDiscount" />
                    <Price className="promotions-content__price" price={promotionsTotal! * -1} />
                  </div>
                </div>
              }
              dataTestId="promotion-discount"
            >
              <div className="multi-promotions">
                <img className="multi-promotions__img" src={getAssetUrl('common/infoBlue.svg')} />
                <FormattedMessage id="payment.promotion.discounts" values={{ number: promotions.length }} />
                <Price price={promotionsTotal! * -1} isDiscount dataTestId="price-discount-multi" />
              </div>
            </ToolTip>
          : <>
              <EllipsisText className="promotions-content__name">
                {promotions[0].name ?? <FormattedMessage id="payment.promotion.fallbackCodeName" />}
              </EllipsisText>
              <Price price={promotions[0].discount * -1} isDiscount dataTestId={`price-discount-${promotions[0].id}`} />
            </>
          }
        </div>
      )}
    </>
  );
};

export default ItemDiscounts;
